import React from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const StandalonePostError = () => {
  return (
    <div className="flex flex-col justify-center items-center h-[calc(100vh-5rem)] px-4 md:px[4rem] text-center">
      <Typography variant="h2" className="text-mainGreen font-semibold">
        Post unavailable
      </Typography>
      <Typography variant="h6">The post you’re looking for may have been removed or the link is incorrect.</Typography>
      <Link to="/" className="flex items-center mt-4">
        <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: "5px" }} />
        <Typography variant="h6" className="text-mainGreen">
          Go back to Home
        </Typography>
      </Link>
    </div>
  );
};

export default StandalonePostError;
